jQuery(document).ready(function ($) {
    "use strict";

    // Enable smooth anchor link scrolling
    // on all link elements (href="#...")
    $.localScroll({target: 'body', offset: -$('.main-header').outerHeight() });

    $('[data-link]').on('click', function (e) {
        e.preventDefault();
        var did = $(this).data('link');
        $('div' + did).toggleClass('is-active');

        if (did !== "#mini-cart" && did !== "#mobilemenu") {
            $('body').toggleClass('overflow-hidden');
        }
    });

    // Tab functionality
    $('[data-tabs]').tabs();

    $('[data-map]').gMap();

    // Opens Magnific Popup's, using the data attribute to group items into a gallery,
    // For dynamic type to work, you will need to add the class mfp-TYPE to all elements.
    // Use mfp-image for images, mfp-iframe for videos, and mfp-inline for HTML.
    /* Look at this further, can be more efficient. */
    $('[data-mfp]').on('click', function (e) {
        e.preventDefault();

        $('[data-mfp]').magnificPopup({
            gallery: {
                enabled: true
            }
        }).magnificPopup('open');
    });

    // Magnific popup for galleries
    $('.magnific-gallery').magnificPopup({
        type: 'image',
        gallery:{
            enabled:true
        }
    });

    // Reset button for WooCommerce search filters
    $('[data-clear-search]').on('click', function(e) {
        $('[data-search-element]').each(function(){
            $(this)[0].value = '';
        });

        $('[data-search-min]').each(function(){
            $(this)[0].value = '0';
        });

        $('[data-search-max]').each(function(){
            $(this)[0].value = '99999999';
        });
    });
});
